import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicNav from './PublicNav';
import PublicFooter from './PublicFooter';
import './ContactPage.css';

const ContactPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="contact-page">
      <PublicNav onLoginClick={() => navigate('/login')} />
      
      <div className="contact-container">
        <header className="contact-header">
          <h1>Contact Us</h1>
          <p className="contact-subtitle">Get in touch with our team</p>
        </header>

        <section className="contact-section">
          <div className="contact-info">
            <p className="contact-intro">
              For questions about the platform, technical support, or partnership inquiries, 
              please reach out to us.
            </p>
            
            <div className="contact-methods">
              <div className="contact-method">
                <div className="contact-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <h3>Email</h3>
                <p>info@decyx.com</p>
              </div>
              
              <div className="contact-method">
                <div className="contact-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </div>
                <h3>Support</h3>
                <p>For technical support or account issues, contact your account administrator.</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Footer */}
      <PublicFooter />
    </div>
  );
};

export default ContactPage;

